/**
 * Converts a File object to a base64 string
 * @param file The file to convert
 * @returns A promise that resolves to the base64 string (including data URL prefix)
 */
export const fileToBase64 = (file: File): Promise<string> => {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = () => resolve(reader.result as string);
    reader.onerror = (error) => reject(error);
  });
};

/**
 * Extracts the base64 data and file type from a data URL
 * Example: data:image/png;base64,iVBOR... -> { type: 'image/png', data: 'iVBOR...' }
 */
export const splitBase64 = (base64String: string) => {
  const [header, data] = base64String.split(';base64,');
  const type = header.split(':')[1];
  return { type, data };
};
